import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { TransactionTypeOptions } from 'utils/Constant';
import { GetPaymentOptions, GetPaymentStatus, GetStatus, GetTransactionStatus, GetTransactionType, money } from 'utils/helpers';

const SalesReportPdf = (data, date1, date2, loc, trxType, locName) => {
    let y = 20
    const totalSales = data.reduce((sum, row) => sum + (parseFloat(row.calculatedTarrif) || 0), 0);
    const totalTransactions = data.length;

    const doc = new jsPDF('p', 'mm', 'a4');
    // const doc = new jsPDF({
    //   orientation: 'p',
    //   unit: 'mm',
    //   format: [200, 100], // e.g., custom height
    // });
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Transaction Report', 15, y);
    y = y + 8

    // Change to default font size and font wight
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');

    doc.text('Tanggal : ' + date1 + ' - ' + date2, 15, y);
    y = y + 5

    doc.text('Lokasi : ' + (loc === '' ? 'Semua Lokasi' : locName), 15, y);
    y = y + 5

    doc.text('Tipe Transaksi : ' + (trxType === '' ? 'Semua Transaksi' : TransactionTypeOptions.find(x => x.value === trxType).label), 15, y);
    y = y + 5

    doc.text(`Total Transaksi : ${totalTransactions}`, 15, y);
    y = y + 5

    doc.text(`Total Penjualan : ${money(totalSales)}`, 15, y);  
    y = y + 6

    const tableBody = data.map((row, index) => [
        index + 1,
        'PR-' + String(row.transactionId), 
        ...(loc === '' ? [row.locationName] : []), // 👈 remove column if trxType !== ''
        moment(row.transactionalDate).format('DD MMM YYYY'),
        moment(row.transactionDate).format('DD MMM YYYY'),
        row.vehicleBrand + " " + row.vehicleModel + " " + row.vehicleColor ,
        row.licensePlateNumber,
        ...(trxType === '' ? [GetTransactionType(row.transactionType)] : []), // 👈 remove column if trxType !== ''
        moment(row.clockIn).format('HH:mm'),
        GetPaymentStatus(row.paymentStatus) ,
        GetPaymentOptions(row.paymentOptions),
        money(row.calculatedTarrif)
    ]);

    autoTable(doc, {
        startY: y,
        head: [[
            'No', 
            'Kode',
            ...(loc === '' ? ['Lokasi'] : []), // 👈 conditional column
            'Tgl. Pembukuan',
            'Tgl. Transaksi',
            'Kendaraan', 
            'Plat Nomor', 
            ...(trxType === '' ? ['Tipe Trx'] : []), // 👈 conditional column
            'Waktu', 
            'Payment Status', 
            'Payment', 
            'Tariff'
        ]],
        body: tableBody,
        styles: {
            fontSize: 8,
            cellPadding: 1,
            lineWidth: 0.1,
        },
        headStyles: {
            fillColor: [215, 215, 215],
            textColor: 0,
            halign: 'center',
            valign: 'middle',
            lineWidth: 0.2,
            lineColor: 0
        },
        bodyStyles: {
            fillColor: [255, 255, 255],
            textColor: 0,
            lineWidth: 0.2,
            lineColor: 0
        },
        alternateRowStyles: {
            fillColor: [255, 255, 255],
        },
        margin: { top: 15, bottom: 10 },
        pageBreak: 'auto',
        didDrawPage: (data) => {
            const pageCount = doc.internal.getNumberOfPages();
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height;

            doc.setFontSize(8);
            doc.text(`Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`, data.settings.margin.left, pageHeight - 5);
        },
    });

    

    let yPos = doc.lastAutoTable.finalY + 10;
    const pageHeight = doc.internal.pageSize.height;

    if (yPos + 20 > pageHeight) {
        doc.addPage();
        yPos = 20;
    }

    // doc.setFontSize(10);
    // doc.setFont('helvetica', 'bold');
    // doc.setTextColor(0);
    // doc.text(`Summary`, 15, yPos);
    // doc.setFontSize(9);
    // doc.setFont('helvetica', 'normal');

    // Open on new tab
    doc.output('dataurlnewwindow');

    // const pdfDataUri = doc.output('datauristring');

    // const link = document.createElement('a');
    // link.href = pdfDataUri;
    // link.download = 'RFQ.pdf';
    // link.click();

    // const newTab = window.open();
    // newTab?.document.write(`<iframe width='100%' height='100%' src='${pdfDataUri}'></iframe>`);
};

export default SalesReportPdf